
import { GET_PROFILE } from '@/dataSource/api/user/apiAuth'
import { getIndexedDB, setIndexedDB } from '@/dataSource/indexed-DB/indexedDB'
import { defineStore } from 'pinia'

export interface TypeDataUserAuth {
    dataUser: any
    dataProfile: any
    type: any
}

export const DashboardAuth = defineStore('DashboardAuth', {
    state: () => <TypeDataUserAuth>({
        dataUser: [],
        dataProfile: [],
    }),
    actions: {
        async CheckAuthUser() {
            if (await getIndexedDB('token')) {
                if (await getIndexedDB('profile')) {
                    this.dataUser = await getIndexedDB('profile')
                    this.dataUser = JSON.parse(this.dataUser)
                } else {
                    this.dataProfile = await GET_PROFILE()
                    setIndexedDB('profile', JSON.stringify(this.dataProfile.data.profile))
                    this.dataUser = this.dataProfile.data.profile
                    this.type = this.dataUser.type
                }
            }

        },
    }
})